import React from 'react';
import { string, object } from 'prop-types';

import { sizeMap } from './common';

const InputPrefixes = ({ prefixText, size, styles }) => {

  return prefixText ?
    <p key="two" className={`${sizeMap[size]} ${styles.prefixText}`}>{prefixText}</p> :
    null;
};

InputPrefixes.propTypes = {
  prefixText: string,
  size: string,
  styles: object,
};

InputPrefixes.displayName='InputPrefixes';

export default InputPrefixes;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/InputPrefixes.js